export const ADD_CATERING_INQUERY = "ADD_CATERING_INQUERY";
export const ADD_CONTACT_INQUERY = "ADD_CONTACT_INQUERY";

export const ADD_MENU_APPETIZER = "ADD_MENU_APPETIZER";
export const ADD_MENU_DUMPLING = "ADD_MENU_DUMPLING";
export const ADD_MENU_RICE = "ADD_MENU_RICE";
export const ADD_MENU_NOODLE = "ADD_MENU_NOODLE";
export const ADD_MENU_MEAT = "ADD_MENU_MEAT";
export const ADD_MENU_DESSERT = "ADD_MENU_DESSERT";

export const FIND_A_TABLE = "FIND_A_TABLE";
export const SELECT_TIME_SLOT = "SELECT_TIME_SLOT";
export const SELECT_ACTIVE_TAB = "SELECT_ACTIVE_TAB";
export const SET_RESERVE_NUM_PEOPLE = "SET_RESERVE_NUM_PEOPLE";
export const SET_RESERVE_DATE = "SET_RESERVE_DATE";
export const SET_RESERVE_TIME = "SET_RESERVE_TIME";
export const SET_RESERVE_CONFIRM_NUM = "SET_RESERVE_CONFIRM_NUM";